import React from 'react';
import { generatePublicUrl, generateMediaUrl, resolveAnyStaticUrl } from '../../urlConfig';
import VoicePlayer from '../../components/media/VoicePlayer';

const isImgByExt = (url = '', name = '') =>
    (url || name || '').toLowerCase().match(/\.(png|jpe?g|gif|webp|bmp|svg)$/);

function normalizePath(p = "") {
    return (p || '').replace(/\/{2,}/g, "/");
}

function pickHref(fileUrl = '', fileType = '', mime = '', fileName = '') {
    if (!fileUrl) return '';

    // поддержка легаси /uploads
    if (fileUrl.startsWith('/uploads/')) {
        fileUrl = '/public' + fileUrl;
    }

    if (fileUrl.startsWith('/media/') || fileUrl.startsWith('/public/')) {
        return resolveAnyStaticUrl(normalizePath(fileUrl));
    }

    const isAudio =
        fileType === 'voice' ||
        (mime && mime.startsWith('audio/')) ||
        /\.(webm|ogg|oga|mp3|m4a|aac|wav)$/i.test(fileUrl);
    const isVideo = (mime && mime.startsWith('video/')) || /\.(mp4|mov|webm|mkv)$/i.test(fileUrl);
    const isImage = (mime && mime.startsWith('image/')) || isImgByExt(fileUrl, fileName);

    const url = (isAudio || isVideo || isImage)
        ? generateMediaUrl(fileUrl)
        : generatePublicUrl(fileUrl);

    return normalizePath(url);
}

export default function Attachment({ message, onOpenImage, onTranscribe }) {
    const { fileUrl, fileName, fileMime, fileType } = message || {};
    if (!fileUrl) return null;

    const mime = ((fileMime == null ? '' : fileMime) + '').toLowerCase(); // <-- ключевая защита
    const href = pickHref(fileUrl, fileType, mime, fileName);

    // AUDIO
    if (
        fileType === 'voice' ||
        (mime && mime.startsWith('audio/')) ||
        /\.(webm|ogg|oga|mp3|m4a|aac|wav)$/i.test(fileUrl)
    ) {
        const doTranscribe = onTranscribe ? () => onTranscribe({ href, fileName }) : undefined;
        // console.log('[ATTACH] voice', { fileUrl, href, fileType, mime });
        return (
            <div className="bubble__voice">
                <VoicePlayer
                    src={href}
                    filename={fileName}
                    durationHintSec={message.voiceId?.durationSec || message.mediaDurationSec || 0}
                    onTranscribe={doTranscribe}
                />
            </div>
        );
    }

    // IMAGE
    if (isImgByExt(fileUrl, fileName) || (mime && mime.startsWith('image/'))) {
        return (
            <button className="bubble__file bubble__file--thumb" onClick={() => onOpenImage?.(href)} title="Открыть">
                <img
                    src={href}
                    alt={fileName || 'image'}
                    style={{ maxWidth: 280, width: '100%', borderRadius: 10, display: 'block' }}
                    onError={() => console.warn('[ATTACH] image error', href)}
                />
            </button>
        );
    }

    // VIDEO
    if ((mime && mime.startsWith('video/')) || /\.(mp4|mov|webm|mkv)$/i.test(fileUrl)) {
        return (
            <video
                className="bubble__video"
                src={href}
                controls
                preload="metadata"
                style={{ maxWidth: 320, width: '100%', borderRadius: 10, display: 'block' }}
                onError={() => console.warn('[ATTACH] video error', href)}
            />
        );
    }

    // DOC
    return (
        <a href={href} target="_blank" rel="noreferrer" className="bubble__file" onClick={() => console.log('[ATTACH] open doc', href)}>
            📎 {fileName || 'Вложение'}
        </a>
    );
}
